import React, { useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { exportPdf } from "../../exportPdf";
import { exportExcel } from "../../exportExcel";

function Window(props) {
  const [reSize, setReSize] = useState(false);
  const [style, setStyle] = useState(props.style || {});
  const [data, setData] = useState({});
  const [exportTime, setExportTime] = useState(new Date().getTime());
  const [exportType, setExportType] = useState(null);

  const handleResize = () => setReSize((prev) => !prev);

  const pdfExport = () => {
    setExportTime(new Date().getTime());
    setExportType("pdf");
  };

  const excelExport = () => {
    setExportTime(new Date().getTime());
    setExportType("excel");
  };

  const excelExportByBrands = () => {
    setExportTime(new Date().getTime());
    setExportType("excel-multisheet");
  };

  const shouldShowBrandExport = () => {
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split("/");
    const lastSegment = pathSegments[pathSegments.length - 1];
    return lastSegment === "item" || lastSegment === "revcentItem";
  };

  const getData = useCallback(
    (incomingData) => {
      setData(incomingData);
      if (exportType === "pdf") {
        switch (incomingData.type) {
          case "image":
            exportPdf.image(incomingData);
            break;
          case "table":
            exportPdf.table(incomingData);
            break;
          default:
            break;
        }
      }
    },
    [exportType]
  );

  const renderdata = (data) => {
    //setExportType(null);

    return exportExcel(data, data.isMultiSheet);
  };

  // Pass export and getData as props to children
  const childrenWithProps = React.cloneElement(props.children, {
    export: exportTime,
    exportType: exportType,
    getData: getData,
  });

  return (
    <div>
      {(exportType === "excel" || exportType === "excel-multisheet") &&
      Object.keys(data).length
        ? renderdata(data)
        : null}
      <div
        className={["window", props.horizontal ? "windowHorizontal" : ""].join(
          " "
        )}
        style={style}
      >
        <div className={["header"]}>
          <div className={["heading"]}>
            <button onClick={handleResize}>
              <FontAwesomeIcon
                className={["icon"].join(" ")}
                icon={["fas", reSize ? "plus-square" : "minus-square"]}
              />
            </button>
            <h2>{props.title}</h2>
          </div>
          <div className={"export"}>
            {shouldShowBrandExport() && (
              <button onClick={excelExportByBrands}>
                <FontAwesomeIcon
                  className={["icon"].join(" ")}
                  icon={["fas", "file-excel"]}
                />
                Export to Excel by Brands
              </button>
            )}
            <button onClick={excelExport}>
              <FontAwesomeIcon
                className={["icon"].join(" ")}
                icon={["fas", "file-excel"]}
              />
              Export to Excel
            </button>
            <button onClick={pdfExport}>
              <FontAwesomeIcon
                className={["icon"].join(" ")}
                icon={["fas", "file-pdf"]}
              />
              Export to PDF
            </button>
          </div>
        </div>
        {props.horizontal ? (
          <div className={["winHori", reSize ? "hide" : ""].join(" ")}>
            <div className={["winBody"].join(" ")}>{childrenWithProps}</div>
          </div>
        ) : (
          <div className={["winBody", reSize ? "hide" : ""].join(" ")}>
            {childrenWithProps}
          </div>
        )}
      </div>
    </div>
  );
}

export default Window;
